import PropTypes from 'prop-types';
import { NumberField, useListContext } from 'react-admin';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { buildListFilterUrl } from '@/helpers/filters/buildListFilterUrl.js';
import DeviceTransactionsField from '@/components/device/DeviceTransactionsField.jsx';
import { DEFAULT_PERIOD } from '@/components/analytics/PeriodFilters.jsx';

export const TransactionsClickable = ({ record }) => {
    const navigate = useNavigate();
    const collectionPointId = record.collectionPoint?.id;
    if (!collectionPointId) return <DeviceTransactionsField record={record} />;
    const handleClick = e => {
        e.stopPropagation();
        navigate(buildListFilterUrl('/transaction', { 'collectionPoint->id_in': [collectionPointId] }, ['collectionPoint->id_in']));
    };
    return (
        <Box sx={{ cursor: 'pointer' }}>
            <DeviceTransactionsField record={record} onClick={handleClick} />
        </Box>
    );
};

TransactionsClickable.propTypes = {
    record: PropTypes.object,
};

export const BagsClickable = ({ record }) => {
    const navigate = useNavigate();
    const { filterValues } = useListContext();
    const currentPeriod = filterValues?.period ?? DEFAULT_PERIOD;
    const source = `analytics[${currentPeriod}].bagsCount`;
    const collectionPointId = record.collectionPoint?.id;
    if (!collectionPointId) return <NumberField source={source} record={record} />;
    const handleClick = e => {
        e.stopPropagation();
        navigate(buildListFilterUrl('/bag', { 'collectionPoint->id_in': [collectionPointId] }, ['collectionPoint->id_in']));
    };

    return (
        <Box sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} onClick={handleClick}>
            <NumberField source={source} record={record} />
        </Box>
    );
};

BagsClickable.propTypes = {
    record: PropTypes.object,
};
